import { Avatar, Modal, Stack, Typography } from '@mui/material';
import { ControlledDropdown } from 'Components/ControlledDropdown';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { AllFilters } from '../AllFilters';
import { Specialties } from './Specialties';
import { General } from './General';
import { Training } from './Training';
import { useContext, useEffect, useState } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { PurpleClose } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { TherapySearchForm } from 'Modules/Suppliers/SuppliersMain/SearchForms/TherapySearchForm';

export const TherapyFilter = () => {
  const { filters, suppliers, isAllFiltersModal, setIsAllFiltersModal } =
    useContext(SuppliersContext);
  const [supplierChangeDetection, setSupplierChangeDetection] =
    useState<boolean>(false);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  useEffect(() => {
    setSupplierChangeDetection((prev) => !prev);
  }, [suppliers]);

  return (
    <Stack
      direction='row'
      gap='24px'
      sx={{
        width: 'fit-content',
        minHeight: '50px',
        flexWrap: 'wrap',
      }}
    >
      {isDesktop && (
        <>
          <ControlledDropdown
            label={dictionary.therapy.sort}
            filterComponent={<General />}
            activeFilters={
              filters.orderByAscendingAlphabet ||
              filters.orderByDescendingAlphabet
                ? 1
                : 0
            }
            closeOnEffect={supplierChangeDetection}
          />
          <ControlledDropdown
            label={dictionary.therapy.therapyMethods}
            filterComponent={<Specialties />}
            activeFilters={filters.treatMethod?.length}
            closeOnEffect={supplierChangeDetection}
          />
          <ControlledDropdown
            label={dictionary.therapy.training}
            filterComponent={<Training />}
            activeFilters={filters.degree?.length}
            closeOnEffect={supplierChangeDetection}
          />
        </>
      )}
      {/* <AllFilters onClick={() => setIsAllFiltersModal(true)} /> */}
      <Modal open={isAllFiltersModal}>
        <Stack
          sx={{
            position: 'absolute',
            top: '100px',
            left: '50%',
            transform: 'translateX(-50%)',
            overflow: 'auto',
            maxHeight: '78vh',
            width: '1000px',
            direction: 'ltr',
            bgcolor: '#FFF',
            borderRadius: '16px',
            border: '1px solid #E7EDFF',
            boxShadow: '-2px -2px 10px 0px #081E540A',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar
            alt={dictionary.closeFilters}
            src={PurpleClose}
            sx={{
              position: 'absolute',
              top: '7px',
              right: '7px',
              ':hover': {
                cursor: 'pointer',
              },
            }}
            tabIndex={0}
            onClick={() => setIsAllFiltersModal(false)}
            onKeyDown={onEnterOrEscapeKeyDown}
          />
          <Typography
            variant='body1'
            sx={{
              fontSize: '28px !important',
              p: '24px 0',
            }}
          >
            {dictionary.allFilters}
          </Typography>
          <TherapySearchForm
            formSx={{
              border: 'none',
              boxShadow: 'none',
            }}
          />
        </Stack>
      </Modal>
    </Stack>
  );
};
